import { PureComponent } from 'react';
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  withRouter,
} from 'react-router-dom';
import { noop } from 'lodash/fp';
import PropTypes from 'prop-types';
import withRestProps from 'helpers/withRestProps';
import { LINK_FORCE_REFRESH } from 'config';

class Link extends PureComponent {
  static propTypes = {
    activeClassName: PropTypes.string,
    forceRefresh: PropTypes.bool,
    history: PropTypes.shape({
      createHref: PropTypes.func.isRequired,
    }).isRequired,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClick: PropTypes.func,
    rest: PropTypes.object,
    target: PropTypes.string,
  };

  static defaultProps = {
    forceRefresh: LINK_FORCE_REFRESH,
    onClick: noop,
  };

  handleClick = (e) => {
    const { forceRefresh, history, onClick, to, target } = this.props;

    onClick(e);

    if (forceRefresh) {
      const href = history.createHref(
        typeof to === 'string' ? { pathname: to } : to,
      );

      e.preventDefault();

      if (target) {
        window.open(href, target).focus();
      } else {
        window.location.href = href;
      }
    }
  };

  render() {
    const { activeClassName, rest, to } = this.props;

    if (activeClassName) {
      return (
        <RouterNavLink
          {...rest}
          activeClassName={activeClassName}
          onClick={this.handleClick}
          to={to}
        />
      );
    }

    return <RouterLink {...rest} onClick={this.handleClick} to={to} />;
  }
}

export default withRestProps()(withRouter(Link));
